export default "__VITE_ASSET__C7mw6Zot__"